export default __webpack_public_path__ + "static/media/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0001.96d5166f.jpg";